import { v4 as uuid } from "uuid";

import { EntityTypes } from "../../EntityTypes";
import { IFrameworkResource } from "../../frameworks";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { IBrand } from "../types/IBrand";
import { mapRelationalValueAsIRI, RelationalValue } from "./../../utils/filters";

export type IBrandCreateMutationParameters = Pick<
    IBrand,
    | "title"
    | "domainUi"
    | "contactEmail"
    | "nbUsersMax"
    | "expiredAt"
    | "contentProtectedViewable"
    | "primaryColor"
    | "secondaryColor"
    | "contentVisibility"
> & {
    uuid?: string;
    frameworks: RelationalValue<IFrameworkResource>[];
    logo?: File;
};

export type IBrandCreateMutationResult = IBrand;

export const brandCreateMutation: IApiMutationFunction<IBrandCreateMutationParameters> = ({
    frameworks,
    logo,
    ...data
}) => {
    const formData = new FormData();

    formData.append("uuid", data.uuid ?? uuid());
    formData.append("title", data.title);
    formData.append("domainUi", data.domainUi);
    formData.append("contactEmail", data.contactEmail);

    formData.append("nbUsersMax", data.nbUsersMax.toString());
    formData.append("expiredAt", data.expiredAt);
    formData.append("contentProtectedViewable", data.contentProtectedViewable.toString());
    formData.append("primaryColor", data.primaryColor ?? "");
    formData.append("secondaryColor", data.secondaryColor ?? "");
    formData.append("contentVisibility", data.contentVisibility);

    frameworks.forEach(framework => {
        const frameworkIRI = mapRelationalValueAsIRI(EntityTypes.FRAMEWORK, framework);
        if (frameworkIRI) {
            formData.append("frameworks[]", frameworkIRI);
        }
    });

    if (logo) {
        formData.append("logo", logo);
    }

    return {
        method: "POST",
        url: "/brands",
        headers: {
            "Content-Type": "multipart/form-data",
        },
        data: formData,
    };
};

export const useBrandCreateMutation = createApiMutationHook<IBrandCreateMutationParameters, IBrandCreateMutationResult>(
    brandCreateMutation,
);
